import React from 'react'
import PropTypes from 'prop-types'
import SwiperComponent from 'react-id-swiper'
import resolveProps from '../../utils/resolveProps'
import useValidations from '../../hooks/use-validation'

const config = {
  types: ['inverse'],
  modifiers: [],
  states: []
}

const params = {
  ContainerEl: 'div',
  containerClass: 'mdn-Swiper mdn-Steps-swiper',
  WrapperEl: 'ul',
  rebuildOnUpdate: true,
  wrapperClass: 'mdn-TabSelect-list mdn-Swiper-wrapper',
  slideClass: 'mdn-TabSelect-item',
  slidesPerView: 'auto',
  pagination: {},
  navigation: {},
  grabCursor: true
}

export default function TabSelect(props) {
  const {
    inverse,
    data,
    dataTabSelect,
    swiperConfigs,
    onClick,
    children,
    gtm,
    currentTab,
    ...rest
  } = props

  const tabsRef = React.useRef(null)
  const tabsId = `tab__${
    new Date()
      .valueOf()
      .toString()
      .match(/\d{6}$/)[0]
  }`
  const { deepEqualObj, shallowEqualObj } = useValidations()
  const items = data || dataTabSelect

  const currentIndex = [...items]?.findIndex(
    (item) => item?.isActive === true || item?.props?.isActive === true
  )
  const initialTab = currentIndex === -1 ? 0 : currentIndex

  const [tabs, setTabs] = React.useState({
    currentTab: initialTab,
    items: items
  })

  React.useEffect(() => {
    if (!shallowEqualObj(tabs.items, data)) {
      const currentPos =
        tabs.currentTab >= data.length ? data.length - 1 : tabs.currentTab
      setTabs({ currentTab: currentPos, items: data })
    }
  }, [data])

  const handleOnclick = React.useCallback((index, isVirtual) => {
    tabsRef.current.swiper.slideTo(tabs.currentTab, 0, false)
    setTabs((state) => {
      return { ...state, currentTab: index }
    })
    !!onClick && !isVirtual && onClick()
  }, [])

  React.useEffect(() => {
    if (!!currentTab) {
      handleOnclick(currentTab, true)
    }
  }, [currentTab])

  return (
    <div className={resolveProps(props, config, 'TabSelect')} {...rest}>
      <SwiperComponent
        {...params}
        activeSlideKey={currentIndex}
        ref={tabsRef}
        a11y={false}
        threshold={10}
      >
        {tabs.items.map((item, index) => {
          const { gtm = {} } = item
          const { gtmClassName = '', dataGTM = {} } = gtm

          return (
            <li
              key={`tab_${index}`}
              className={`${
                tabs.currentTab === index ? 'mdn-TabSelect-active' : ''
              } `}
              aria-owns={`item-tab-${tabsId}-${index}`}
              aria-controls={`item-tab-${tabsId}-${index}`}
            >
              <button
                {...dataGTM}
                onClick={() => handleOnclick(index)}
                type="button"
                className={`mdn-TabSelect-anchor ${gtmClassName}`}
              >
                {item.title}
              </button>
            </li>
          )
        })}
      </SwiperComponent>
      <div className="mdn-TabSelect-content">
        {tabs?.items?.map((item, index) => {
          return (
            <div
              key={`tab_${index}`}
              id={`item-tab-${tabsId}-${index}`}
              aria-hidden={tabs.currentTab !== index}
              style={{
                display: `${tabs.currentTab === index ? 'flex' : 'none'}`
              }}
              className="mdn-TabSelect-panel mdn-TabSelect-active"
            >
              {tabs.currentTab === index ? items[index]?.content : null}
            </div>
          )
        })}
      </div>
    </div>
  )
}

TabSelect.propTypes = {
  swiperConfigs: PropTypes.bool
}
